export const hasPolicyPermission = (policies, action) => {
  if (!Array.isArray(policies)) return false;

  const [prefix, resource, operation] = action.split(":"); // e.g., api:isin:edit

  return policies.some(policy => {
    try {
      const policyDoc = JSON.parse(policy.policyDocument);

      // 1️⃣ Check if allowed via Action match or wildcard
      const actionAllowed = policyDoc.Statement.some(statement => {
        const allowed = statement.Effect === "Allow";
        const matchesAction =
          statement.Action.includes(action) ||            // exact match
          statement.Action.includes(`${prefix}:${resource}:*`) || // wildcard match
          statement.Action.includes("*");                // global wildcard
        return allowed && matchesAction;
      });

      if (actionAllowed) return true;

      // 2️⃣ Check if description grants full access for the resource
      if (
        policy.description &&
        policy.description.toLowerCase().includes("full access") &&
        policy.description.toLowerCase().includes(resource.toLowerCase())
      ) {
        return true;
      }

      return false;
    } catch (e) {
      console.error("Error parsing policyDocument:", e);
      return false;
    }
  });
};
